//@config
export default {
  auth: {
    cooperation_request: "v1/cooperation_request",
    redirectAzmoon: "v1/out/{0}/azmoon",
    captcha: "v1/captcha",
    check_login: "v1/check_login",
    auth: "v1/auth",
    two_step: "v1/two_step",
    auth_mobile: "v1/auth_mobile",
    generate_otp_code_wt: "v1/generate_otp_code_wt",
    change_password: "v1/change_password",
    contactUs: "v1/contact_us",
    logout: "v1/logout",
  },
  pre_register: {
    active_registrations: "v1/pre_register_active_registrations",
    detail_registration: "v1/pre_register_detail_registration/{0}",
    send_mobile: "v1/pre_register_send_mobile",
    confirm_mobile: "v1/pre_register_confirm_mobile",
    confirm_registration_code: "v1/pre_register_confirm_registration_code",
    pre_register: "v1/pre_register",
  },
  newRegister: {
    pre_register_active_registrations: "v1/pre_register_active_registrations",
    pre_register_detail_registration: "v1/pre_register_detail_registration/{0}",
    pre_register_send_mobile: "v1/pre_register_send_mobile",
    pre_register_confirm_mobile: "v1/pre_register_confirm_mobile",
    pre_register_confirm_registration_code:
      "v1/pre_register_confirm_registration_code",
    pre_register: "v1/pre_register",
  },
};
